import * as rulesetGift from './gifts.ruleset';
import { Immutable } from '@play-co/replicant';
import { ReplicantModuleState } from '../../utils';

import giftSchema from './gifts.schema';
import giftsActions from './gifts.actions';
import giftsMessages from './gifts.messages';
import giftsGetters from './gifts.getters';

// Dependencies
import { Inventory } from '../inventory';

export type Gifts = typeof Gifts;
// eslint-disable-next-line no-redeclare
export namespace Gifts {
  export const $DEPENDENCIES = { Inventory };

  export const ruleset = rulesetGift;
  export const schema = giftSchema;
  export const getters = giftsGetters(Gifts, $DEPENDENCIES);
  export const messages = giftsMessages;
  export const actions = giftsActions(Gifts, $DEPENDENCIES);

  export type MutableState = ReplicantModuleState<Gifts>;
  export type State = Immutable<MutableState>;
}
